import Layout from '@/views/main/Main.vue'
import type { RouteRecordRaw } from "vue-router";
const supplierRouter: RouteRecordRaw = {
    path: '/supplier',
    component: Layout,
    redirect: 'noredirect',
    meta: {
        icon: 'el-icon-s-custom',
        title: '供应商'
    },
    children: [
        {
            path: '/supplier/deliveryOrderManagement',
            component: () => import("@/views/main/supplier/deliveryOrderManagement/deliveryOrderManagement.vue"),
            name: 'deliveryOrderManagement',
            meta: {
                title: '采购单管理'
            }
        },
        {
            path: '/supplier/deliveryAppointment',
            component: () => import("@/views/main/supplier/deliveryAppointment/deliveryAppointment.vue"),
            name: 'deliveryAppointment',
            meta: {
                title: '送货单预约'
            }
        },
        {
            path: '/supplier/awayManagement',
            component: () => import("@/views/main/supplier/awayManagement/awayManagement.vue"),
            name: 'awayManagement',
            meta: {
                title: '送货单管理'
            }
        },
        {
            path: '/supplier/deliveryOrder',
            component: () => import("@/views/main/supplier/deliveryOrder/deliveryOrder.vue"),
            name: 'deliveryOrder',
            meta: {
                title: '送货单管理'
            }
        },        
        {
            path: '/supplier/receiving',
            component: () => import("@/views/main/supplier/receiving/receiving.vue"),
            name: 'receiving',
            meta: {
                title: '不良明细'
            }
        },
        {
            path: '/supplier/defectRate',
            component: () => import("@/views/main/supplier/defectRate/defectRate.vue"),
            name: 'defectRate',
            meta: {
                title: '供应商不良率'
            }
        },
        {
            path: '/supplier/nonstandard',
            component: () => import("@/views/main/supplier/nonstandard/nonstandard.vue"),
            name: 'nonstandard',
            meta: {
                title: '加急件管理'
            }
        },{
            path: '/supplier/receivingManage',
            component: () => import("@/views/main/supplier/receivingManage/receivingmanage.vue"),
            name: 'receivingManage',
            meta: {
                title: '收货管理'
            }
        },
        {
            path: '/supplier/deliveryNoteManagement',
            component: () => import("@/views/main/supplier/deliveryNoteManagement/deliveryNoteManagement.vue"),
            name: 'deliveryNoteManagement',
            meta: {
                title: '送货单管理查询'
            }
        },
        // {
        //     path: '/supplier/receivingList',
        //     component: () => import("@/views/main/supplier/receivingList/receivingList.vue"),
        //     name: 'receivinglist',
        //     meta: {
        //         title: '收货列表'
        //     }
        // }
    ]
}
export default supplierRouter